module.exports = __webpack_public_path__ + "img/40.3.TP.aefb45e7.png";